(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gear-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!window.musGearScroll) {
    window.musGearScroll = true;
    document.addEventListener('click', (event) => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target.closest('a[href*="#"]');
      if (!link) return;
      const url = new URL(link.href, window.location.href);
      if (!url.hash || url.pathname !== window.location.pathname) return;
      const target = document.getElementById(decodeURIComponent(url.hash.slice(1)));
      if (!target || !target.classList.contains('gear')) return;

      event.preventDefault();
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      history.pushState(null, '', url.hash);
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["photo-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('photo-carousel')) {
    customElements.define(
      'photo-carousel',
      class PhotoCarousel extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          this.arrows = this.querySelectorAll('[data-dir]');
          if (!this.track) return;
          this.arrows.forEach((button) =>
            button.addEventListener('click', () => this.go(Number(button.dataset.dir)))
          );
          this.update = this.update.bind(this);
          this.track.addEventListener('scroll', this.update, { passive: true });
          this.update();
        }

        go(dir) {
          const slide = this.track.querySelector('li');
          if (!slide) return;
          const step = slide.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || 0);
          const smooth = !matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.track.scrollBy({ left: dir * step, behavior: smooth ? 'smooth' : 'auto' });
        }

        update() {
          const max = this.track.scrollWidth - this.track.clientWidth - 2;
          const [prev, next] = this.arrows;
          if (prev) prev.disabled = this.track.scrollLeft <= 2;
          if (next) next.disabled = this.track.scrollLeft >= max;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["showroom"] && !Shopify.designMode) return;
  try {
    
  class VideoFacade extends HTMLElement {
    connectedCallback() {
      const poster = this.querySelector('a');
      if (!poster) return;
      poster.addEventListener('click', (event) => {
        event.preventDefault();
        const iframe = document.createElement('iframe');
        iframe.src = `https://www.youtube-nocookie.com/embed/${this.dataset.videoId}?rel=0&autoplay=1`;
        iframe.title = this.dataset.title || '';
        iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
        iframe.allowFullscreen = true;
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        poster.replaceWith(iframe);
        iframe.focus();
      });
    }
  }

  if (!customElements.get('video-facade')) customElements.define('video-facade', VideoFacade);

  } catch(e) { console.error(e); }
})();
})();
